import { useLocation, useNavigate } from "react-router-dom";
import { ButtonDefault } from "./Buttons";

const Navigation = (props) => {
  let navigate = useNavigate();
  let location = useLocation();

  const { pathname } = location;

  return (
    <>
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <nav className="mt-16 flex w-full flex-wrap justify-start gap-4">
          <ButtonDefault
            color={pathname === "/find-budget" ? "plainActive" : "plain"}
            label="Calculate my budget"
            onClick={() => navigate("/find-budget")}
          />
          {/* MOVED: Rent to Mortgage tab now sits here, between Calculate my budget */}
          {/* and Available rates. */}
          {/* Previously: this button was placed after Available rates (and before */}
          {/* the hidden Start my mortgage tab / Book an appointment) */}
          <ButtonDefault
            color={pathname === "/rent-to-mortgage" ? "plainActive" : "plain"}
            label="Rent to Mortgage"
            onClick={() => navigate("/rent-to-mortgage")}
          />
          <ButtonDefault
            color={pathname === "/find-mortgage" ? "plainActive" : "plain"}
            label="Available rates"
            onClick={() => navigate("/find-mortgage")}
          />
          {/* HIDDEN: Start my mortgage tab — work in progress, not ready for display */}
          {/* Previously visible:
          <ButtonDefault
            color={pathname === "/start-mortgage" ? "plainActive" : "plain"}
            label="Start my mortgage"
            onClick={() => navigate("/start-mortgage")}
          /> */}
          {/* ADDED: Book an appointment tab */}
          {/* Previously: not present in Navigation.jsx — contact was only accessible via Header button */}
          <ButtonDefault
            color={pathname === "/contact" ? "plainActive" : "plain"}
            label="Book an appointment"
            onClick={() => navigate("/contact")}
          />
        </nav>
      </div>
    </>
  );
};

export default Navigation;
